import { render, staticRenderFns } from "./Microservices.vue?vue&type=template&id=6a83753e&scoped=true&"
import script from "./Microservices.vue?vue&type=script&lang=js&"
export * from "./Microservices.vue?vue&type=script&lang=js&"
import style0 from "./Microservices.vue?vue&type=style&index=0&id=6a83753e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a83753e",
  null
  
)

component.options.__file = "Microservices.vue"
export default component.exports